const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_ERROR = 'LOGIN_ERROR'
const LOGOUT = 'LOGOUT'
const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'

export default {
  namespaced: true,
  state: {
    user: localStorage.getItem('user'),
    authenticated: !!localStorage.getItem('token'),
    token: localStorage.getItem('token'),
    isConventional: !!localStorage.getItem('isConventional'),
    isManager: false
  },
  mutations: {
    [LOGIN] (state) {
      state.do_login = true
    },
    [LOGIN_SUCCESS] (state) {
      state.authenticated = true
      state.do_login = false
    },
    [LOGIN_ERROR] (state) {
      state.do_login = false
    },
    [LOGOUT] (state) {
      state.authenticated = false
    },
    [CHANGE_PASSWORD] (state) {
      state.do_change_password = true
    },
    [CHANGE_PASSWORD_SUCCESS] (state) {
      state.do_change_password = false
    },
    [CHANGE_PASSWORD_ERROR] (state) {
      state.do_change_password = false
    }

  },
  actions: {
    login ({ commit, state, getters, rootState }, creds) {
      commit(LOGIN)
      return this.dispatch('request', { method: 'post', url: 'token', data: creds })
      .then(
        response => {
          localStorage.setItem('user', creds.username)
          state.user = creds.username
          localStorage.setItem('token', response.data.token)
          state.token = response.data.token
          this.dispatch('auth/setConventionalStatus', false)
          commit(LOGIN_SUCCESS)
          return response
        }
      ).catch(() => {
        commit(LOGIN_ERROR)
      })
    },
    logout ({ commit, state }) {
      localStorage.removeItem('user')
      localStorage.removeItem('userId')
      localStorage.removeItem('token')
      localStorage.removeItem('isConventional')
      commit(LOGOUT)
    },
    changePassword ({ commit, state, getters, rootState }, oldNew1New2Passwd) {
      commit(CHANGE_PASSWORD)
      return this.dispatch('request', { method: 'post', url: 'rest-auth/password/change', data: oldNew1New2Passwd })
      .then(
        response => {
          rootState.notification = {
            group: 'global',
            duration: 4000,
            type: 'success',
            title: 'Change password',
            text: 'Sucessfully saved new password'
          }
          commit(CHANGE_PASSWORD_SUCCESS)
          return response
        }
      ).catch(() => {
        commit(CHANGE_PASSWORD_ERROR)
      })
    },
    setConventionalStatus ({ commit, state }, value) {
      if (!value) {
        localStorage.removeItem('isConventional')
      } else {
        localStorage.setItem('isConventional', value)
      }
      state.isConventional = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js